export default "<div class=\"container\">\n    <header class=\"jumbotron\">\n      <p>{{ content }}</p>\n    </header>\n  </div>\n\n"